const React = require("react");
const { Routes, Route, Navigate } = require("react-router-dom");
const { PrintfulProvider } = require("./context/PrintfulContext");
const { PrintfulLayout } = require("./components/PrintfulLayout");
const { DropshippingPlatforms } = require("./pages/DropshippingPlatforms");
const { DropshippingPlatformDetails } = require("./pages/DropshippingPlatformDetails");
const { DropshippingPrintfulConnect } = require("./pages/DropshippingPrintfulConnect");
const { DropshippingSuppliers } = require("./pages/DropshippingSuppliers");
const { DropshippingSupplierProducts } = require("./pages/DropshippingSupplierProducts");
const { DropshippingAllProducts } = require("./pages/DropshippingAllProducts");
const { DropshippingProductDetails } = require("./pages/DropshippingProductDetails");
const { DropshippingImportedProducts } = require("./pages/DropshippingImportedProducts");
const { DropshippingOrders } = require("./pages/DropshippingOrders");
const { DropshippingApiErrors } = require("./pages/DropshippingApiErrors");
const { DropshippingAdmin } = require("./pages/DropshippingAdmin");
const h = React.createElement;

const PrintfulRoutes = () => h(Routes, null,
  h(Route, { element: h(PrintfulLayout) },
    h(Route, { path: "printful", element: h(DropshippingPlatforms) }),
    h(Route, { path: "printful/details", element: h(DropshippingPlatformDetails) }),
    h(Route, { path: "printful/connect", element: h(DropshippingPrintfulConnect) }),
    h(Route, { path: "printful/connected", element: h(DropshippingPrintfulConnect) }),
    h(Route, { path: "printful/suppliers", element: h(DropshippingSuppliers) }),
    h(Route, { path: "printful/suppliers/:supplierId/products", element: h(DropshippingSupplierProducts) }),
    h(Route, { path: "printful/products", element: h(DropshippingAllProducts) }),
    h(Route, { path: "printful/products/:productId", element: h(DropshippingProductDetails) }),
    h(Route, { path: "printful/imported", element: h(DropshippingImportedProducts) }),
    h(Route, { path: "printful/orders", element: h(DropshippingOrders) }),
    h(Route, { path: "printful/errors", element: h(DropshippingApiErrors) }),
    h(Route, { path: "printful/admin", element: h(DropshippingAdmin) }),
    h(Route, { path: "printful/*", element: h(Navigate, { to: "/dropshipping/printful", replace: true }) })
  )
);

const PrintfulApp = ({ baseUrl, token, translate, roleName }) => h(PrintfulProvider, { baseUrl, token, translate, roleName }, h(PrintfulRoutes));
module.exports = { PrintfulApp, PrintfulRoutes };
